module.exports = __webpack_public_path__ + "static/media/notification-icon.b49b596f.svg";